<template>
  <el-tooltip
    v-if="fullName"
    :content="fullName"
    placement="top"
    effect="dark"
  >
    <span class="metabolite-label">{{ value }}</span>
  </el-tooltip>
  <span v-else>{{ value }}</span>
</template>

<script>
import request from '@/utils/request'

let labelsPromise

function loadLabels() {
  if (!labelsPromise) {
    labelsPromise = request.get('/api/mqtl/labels').catch(() => [])
  }
  return labelsPromise
}

export default {
  name: 'MetaboliteTooltip',
  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      labelMap: {}
    }
  },
  computed: {
    fullName() {
      const key = String(this.value || '').trim().toLowerCase()
      return key ? this.labelMap[key] || '' : ''
    }
  },
  created() {
    loadLabels().then(labels => {
      const map = {}
      ;(Array.isArray(labels) ? labels : []).forEach(label => {
        const fullName = String(label.name || '').trim()
        if (!fullName) return
        ;[label.abbreviation, label.id].forEach(alias => {
          const key = String(alias || '').trim().toLowerCase()
          if (key) map[key] = fullName
        })
        map[fullName.toLowerCase()] = fullName
      })
      this.labelMap = map
    })
  }
}
</script>

<style lang="less" scoped>
.metabolite-label {
  border-bottom: 1px dotted currentColor;
  cursor: help;
}
</style>
